import WebFontLoader from 'webfontloader';

// async load fonts
WebFontLoader.load({
  google: {
    families: ['Barlow:400,500,700,900', 'Inter:400,500,700,900', 'Big+Shoulders+Display:400,500,700,800'],
  },
});
